// Chakra imports
import { 
  Avatar, 
  Box, 
  Flex, 
  Text, 
  Input, 
  IconButton,
  useColorModeValue 
} from "@chakra-ui/react";
import { EditIcon } from "@chakra-ui/icons";
import Card from "components/card/Card.js";
import React, { useRef } from "react";

export default function Banner(props) {
  const { 
    banner, 
    avatar, 
    name, 
    job, 
    posts, 
    followers, 
    following,
    isEditing = false,
    onPhotoChange 
  } = props;
  
  const fileInputRef = useRef(null);
  // Chakra Color Mode
  const textColorPrimary = useColorModeValue("secondaryGray.900", "white");
  const textColorSecondary = "gray.400";
  const borderColor = useColorModeValue(
    "white !important",
    "#111C44 !important"
  );

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file && onPhotoChange) {
      const reader = new FileReader();
      reader.onload = (e) => {
        onPhotoChange(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleEditPhoto = () => {
    fileInputRef.current?.click();
  };

  return (
    <Card mb={{ base: "0px" }} align='center'>
      <Box
        // bg={`url(${banner})`}
        bgSize='cover'
        borderRadius='16px'
        h='131px'
        w='100%'
      />
      <Box position="relative">
        <Avatar
          mx='auto'
          src={avatar}
          h='87px'
          w='87px'
          mt='-43px'
          border='4px solid'
          borderColor={borderColor}
        />
        {isEditing && (
          <>
            <IconButton
              icon={<EditIcon />}
              size="sm"
              isRound
              position="absolute"
              bottom="0"
              right="0"
              onClick={handleEditPhoto}
              colorScheme="blue"
              bg="blue.500"
              color="white"
              _hover={{ bg: "blue.600" }}
            />
            <Input
              ref={fileInputRef}
              type="file"
              accept="image/*"
              onChange={handleFileChange}
              display="none"
            />
          </>
        )}
      </Box>
      
      <Text color={textColorPrimary} fontWeight='bold' fontSize='xl' mt='10px'>
        {name}
      </Text>
      <Text color={textColorSecondary} fontSize='sm'>
        {job}
      </Text>
    </Card>
  );
}
